<template>
    <div class="container-map">
        <v-chart ref="mapChart" :options="mergedConfig" :initOptions="initOptions" autoresize/>
    </div>
</template>

<script>
import { deepMerge } from '@jiaminghi/charts/lib/util/index'
import { deepClone } from '@jiaminghi/c-render/lib/plugin/util'
import ECharts from 'vue-echarts'
import echarts from "echarts"
import 'echarts/lib/chart/map'
import 'echarts/lib/chart/scatter'
import 'echarts/lib/chart/effectScatter'
import 'echarts/map/js/china'
import 'echarts/lib/component/polar'
import 'echarts/lib/component/markPoint'
import 'echarts/lib/component/dataZoom'
import 'echarts/lib/component/title'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'zrender/lib/svg/svg'

export default {
  name: 'mapChart',
  props: {
    config: {
      type: Object,
      default: () => ({})
    },
    data: {
        type: Object,
        default: () => {}
    }
  },
  data () {
    return {
        initOptions: {renderer: 'svg'},
        option:{},
        defaultConfig: {
            tooltip: {
                show: true,
                alwaysShowContent:true,
                formatter: function(params) {
         
                    if (params.data) {
                        if(params.data.value.length>2){
                        return '&nbsp;&nbsp;' + params.data.name + '&nbsp;&nbsp;&nbsp;' +params.data.value[2] + '家门店&nbsp;&nbsp;'+'</br>'+'本月销售&nbsp;&nbsp;¥'+params.data.value[3];
                    }else{
                        return '&nbsp;&nbsp;' + params.data.name + '&nbsp;&nbsp;&nbsp;' +params.data.value[0] + '家门店&nbsp;&nbsp;'+'</br>'+'本月销售&nbsp;&nbsp;¥'+params.data.value[1];
                    }
                        
                    } 
                    else {
                        return '&nbsp;&nbsp;' + params.name + '&nbsp;&nbsp;&nbsp;' + 0 + '家门店&nbsp;&nbsp;'+'</br>'+'本月销售&nbsp;&nbsp;¥0';
                    }
                    
                },
                position:['40%','85%']

            },
            geo: {
                map: 'china',
                show: true,
                roam: false,
                left: 10,
                right: 10,
                top: 10,
                label: {
                    emphasis: {
                        show: false
                    }
                },
                layoutSize: "100%",
            },
            series: [{
                type: 'map',
                map: 'china',
                aspectScale: 0.75,
                left: 10,
                right: 10,
                top: 10,
                label: {
                    normal: {
                        show: false,
                    },
                    emphasis: {
                        show: false,
                    }
                },
                itemStyle: {
                    normal: {
                        areaColor: {
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [{
                                offset: 0,
                                color: '#073684' // 0% 处的颜色
                            }, {
                                offset: 1,
                                color: '#061E3D' // 100% 处的颜色
                            }],
                        },
                        borderColor: '#215495',
                        borderWidth: 1,
                    },
                    emphasis: {
                        areaColor: {
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [{
                                offset: 0,
                                color: '#073684' // 0% 处的颜色
                            }, {
                                offset: 1,
                                color: '#061E3D' // 100% 处的颜色
                            }],
                        },
                    }
                },
                data: [],
            }, {
                type: 'effectScatter',
                coordinateSystem: 'geo',
                rippleEffect: {
                    brushType: 'stroke'
                },
                showEffectOn: 'render',
                emphasis: {
                    itemStyle: {
                        color: {
                            type: 'radial',
                            x: 0.5,
                            y: 0.5,
                            r: 0.5,
                            colorStops: [{
                                offset: 0,
                                color: 'rgba(243,74,74,0.2)'
                            }, {
                                offset: 0.6,
                                color: 'rgba(243,74,74,0.2)'
                            }, {
                                offset: 1,
                                color: 'rgba(243,74,74,0.9)'
                            }],
                            global: false // 缺省为 false
                        }
                    }
                },
                itemStyle: {
                    normal: {
                        color: {
                            type: 'radial',
                            x: 0.5,
                            y: 0.5,
                            r: 0.5,
                            colorStops: [{
                                offset: 0,
                                color: 'rgba(234,205,44,0.2)'
                            }, {
                                offset: 0.6,
                                color: 'rgba(234,205,44,0.2)'
                            }, {
                                offset: 1,
                                color: 'rgba(234,205,44,0.9)'
                            }],
                            global: false // 缺省为 false
                        },
                    },
                },
                label: {
                    normal: {
                        show: true,
                        color: '#fff',
                        fontWeight: 'bold',
                        position: 'inside',
                        formatter: function(para) {                       
                            return  para.data.value[2] 
                        },
                        rich: {
                            cnNum: {
                                fontSize: 13,
                                color: '#D4EEFF',
                            }
                        }
                    },
                },
                symbol: 'circle',
                data: [],
                zlevel: 1,
            }]
        },
        mergedConfig: null,
        outdata:[],
        timer:null,
    }
  },
  watch: {
    data() {
      const { calcData } = this
      calcData()
    }
  },
  methods: {
    fontSize(res){
         let clientWidth = window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth;
        if (!clientWidth) return;
        let fontSize = (clientWidth / 1920);
        return res*fontSize;
    },
    calcData() {
      const { mergeConfig } = this
      mergeConfig()

    },
    mergeConfig() {
      let { config, defaultConfig,data } = this
      this.$refs.mapChart.clear()
      this.mergedConfig = deepMerge(
        deepClone(defaultConfig, true),
        config || {}
      )
      var valueArray = []
      this.outdata = []
            // debugger
      for (var i = 0; i < data.list.length; i++) {
        this.outdata.push({
            name: data.list[i].name,
            value: [data.list[i].channel,data.list[i].money]
        })
        valueArray.push(data.list[i].channel)
      }
      this.mergedConfig.series[0].data = this.outdata
      this.mergedConfig.series[1].data = this.convertData(this.outdata)
      this.mergedConfig.series[1].symbolSize = function(val) {
          
                    if (val[2] === 0) {
                        return 0;
                    }
                    if(val[2] < 10){
                        return 15;
                    }

                    if(val[2] >= 10){
                        return 25;
                    }

                    return val[2]/2
                    
                }
                
      
    },
    convertData(outdata){
        var geoCoordMap = {};
        /*获取地图数据*/
        var mapFeatures = echarts.getMap('china').geoJson.features;   
        mapFeatures.forEach(function(v) {
            var name = v.properties.name;
            // 地区经纬度
            geoCoordMap[name] = v.properties.cp;

        });
        var res = [];
        for (var i = 0; i < outdata.length; i++) {
            var geoCoord = geoCoordMap[outdata[i].name];
            if (geoCoord) {
                res.push({
                    name: outdata[i].name,
                    value: geoCoord.concat(outdata[i].value),
                });
            }
        }
        return res;
    }

  },
  mounted () {
    const { calcData,$refs,data  } = this
    let FLAG = 0
    calcData()
    this.timer = setInterval(()=>{
        if(FLAG === data.length){
            FLAG = 0
            $refs.mapChart.dispatchAction({type: 'downplay',seriesIndex: 1,dataIndex: data.length-1 });
        }else{
            $refs.mapChart.dispatchAction({type: 'downplay',seriesIndex: 1,dataIndex: FLAG == 0 ? 0 : FLAG-1 });
        }
        $refs.mapChart.dispatchAction({type: 'highlight',seriesIndex: 1,dataIndex: FLAG });
        $refs.mapChart.dispatchAction({type: 'showTip',seriesIndex: 0,dataIndex: FLAG });
        FLAG+=1
    }, 10000);
  },
  beforeDestroy: function() {
            if (this.timer) {
                clearInterval(this.timer);
            }
  },
  components: {
      'v-chart': ECharts
  }
}
</script>
<style lang="scss" type="text/scss">

    .container-map{
        .echarts{
            width: 100%;
            height: 100%;
        }
    }

</style>